export default __webpack_public_path__ + "static/media/page3.88563fdb.png";